import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import { init } from '../ps-popup';
init();

export default {
  config,
} as ModuleConfig;
